import React from "react";
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import project3Img from '../images/Project3.png';
import project4Img from '../images/Project4.png';
import provenImg from '../images/Provenimg.png';
import willisLegacyImg from '../images/Willisimg.png';

export default function ProjectsPage() {
const projects = [
    {
      title: "Proven Pool Pros",
      badge: "Live Business Website",
      img: provenImg,
      description:
        "An official business website built for Proven Pool Pros LLC, a luxury-focused pool maintenance company serving DFW & surrounding areas. Designed to provide a premium customer experience while supporting real client lead generation and service inquiries.",
      features: [
        "Official Company Website: Developed for real-world business usage, customer lead generation, and digital branding.",
        "Luxury One-Page Design: Clean modern layout with premium branding and smooth section flow.",
        "Service Showcase: Weekly maintenance, equipment repair, filter cleaning, and green-to-clean recovery sections.",
        "Interactive Quote Form: Mobile-friendly contact form with selectable service options and lead capture integration.",
        "Responsive UI/UX: Optimized for desktop and mobile with custom animations, FAQ dropdowns, and strong call-to-actions.",
      ],
      tech: ["React", "Vite", "CSS", "JavaScript", "Formspark"],
      live: "https://provenpoolpros.com",
      repo: "https://github.com/Joshua-Pierson/Proven-Pool-Pros.git",
    },
    {
      title: "Willis Legacy Logistics",
      badge: "Live Business Website",
      img: willisLegacyImg,
      description:
        "An official business website built for Willis Legacy Logistics, a professional courier and logistics company providing fast, reliable same-day delivery services across the Dallas–Fort Worth area. Designed to support real business operations, customer inquiries, and brand growth.",
      features: [
        "Official Company Website: Developed for real-world logistics operations, customer lead generation, and digital branding.",
        "Modern Logistics Landing Page: Clean hero section with strong branding and service-focused messaging.",
        "Service Sections: Same-day delivery, medical courier, routed deliveries, and legal document transport.",
        "Quick Quote Contact Form: Streamlined lead capture form for businesses requesting delivery services.",
        "Responsive Business UI: Mobile-optimized layout with trust-building sections, certifications, FAQs, and call-to-action design.",
      ],
      tech: ["React", "Vite", "CSS", "JavaScript", "Formspark"],
      live: "https://willislegacylogistics.com",
      repo: "https://github.com/YOUR-USERNAME/YOUR-REPO-NAME",
    },
    {
      title: "Login & Registration App",
      img: project4Img,
      description:
        "A secure authentication app with registration and login capabilities for easy account management.",
      features: [
        "User Auth: Create, login, securely manage accounts.",
        "Session Handling: Tracks active users and redirects on login/logout.",
      ],
      tech: ["React", "Node.js", "MySQL", "HTML", "CSS", "Bootstrap"],
      live: null,
      repo: "https://github.com/Joshua-Pierson/project4-LoginReg.git",
    },
    {
      title: "To-Do List App",
      img: project3Img,
      description:
        "A clean task manager to organize daily responsibilities. Sleek, responsive UI for work and personal goals.",
      features: [
        "Task Management: Add, edit, delete tasks quickly.",
        "Progress Tracking: Mark completed tasks.",
        "Navigation: React routing across Home, To-Do, Contact.",
        "Responsive Design: Bootstrap-based for all screens.",
      ],
      tech: ["React", "JavaScript", "HTML", "CSS", "Bootstrap", "Google Fonts"],
      live: "https://joshua-pierson.github.io/react-project3-webapp/",
      repo: "https://github.com/Joshua-Pierson/react-project3-webapp.git",
    },
  ];

  return (
    <Container className="py-5 ">
      <h1 className="text-center mb-5 projectStyle">💻 My Projects</h1>
      <Row className="g-4">
        {projects.map((project, idx) => (
          <Col key={idx} xs={12} md={6}>
            <Card className="shadow rounded-4 h-100 hover-scale">
              <Card.Img
                variant="top"
                src={project.img}
                className="rounded-top"
              />
              <Card.Body>
                {project.badge && (
                  <span className="projectBadge">
                    {project.badge}
                  </span>
                )}
                <Card.Title className="fs-4 fw-bold">{project.title}</Card.Title>
                <Card.Text>{project.description}</Card.Text>
              </Card.Body>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <ul className="ps-3 mb-2">
                    {project.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Technologies:</strong>{" "}
                  {project.tech.map((tech, i) => (
                    <span key={i} className="badge bg-primary me-2 mb-1">
                      {tech}
                    </span>
                  ))}
                </ListGroup.Item>
              </ListGroup>
              <Card.Body className="d-flex justify-content-between">
                {project.live ? (
                  <Card.Link
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Live 
                  </Card.Link>
                ) : (
                  <Card.Link disabled className="text-muted">
                    Coming Soon
                  </Card.Link>
                )}
                <Card.Link
                  href={project.repo}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub Repo
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
